module.exports = __webpack_public_path__ + "static/media/option.64dea528.svg";